<script>
export default {
  name: 'RtOriginProgress',
  render (h) {
    return h('el-progress', {
      attrs: this.$attrs,
      props: this.$props,
      class: 'rt-origin-progress'
    });
  }
};
</script>



// WEBPACK FOOTER //
// rtOriginProgress.vue?36caf937